module.exports = __webpack_public_path__ + "img/2.b13ae478.jpg";